import { defineStore } from 'pinia';
import { DeliveryPricesRequestFilter } from '@/types/delivery-price.type.ts';

export const useDeliveryPricesFilterStore = defineStore('delivery-prices.filter', {
    state: (): DeliveryPricesRequestFilter => ({
        page: 1,
        brand_id: undefined,
        model_id: undefined,
        city_from_id: undefined,
        city_to_id: undefined,
        price: undefined,
        sort: [{ city_from_name: 'asc' }],
    }),
});
